module.exports = __webpack_public_path__ + "img/img19.9ce7a2c9.svg";